(() => {
  const age = document.querySelector('[data-age-verification]');
  const welcome = document.querySelector('[data-book-welcome]');
  const offer = document.querySelector('[data-book-promo]');
  const ageKey = 'warehouseh:age-21-until:v1';
  const welcomeKey = 'warehouseh:book-welcome:v1';
  const offerKey = 'warehouseh:book-offer-dismissed:v1';
  let welcomeTimer;
  let offerTimer;
  let dismissed = false;
  const read = (name, key) => { try { return window[name].getItem(key); } catch { return null; } };
  const write = (name, key, value = '1') => { try { window[name].setItem(key, value); } catch {} };
  let ageConfirmed = Number(read('localStorage', ageKey)) > Date.now();
  const scheduleOffer = (delay = 5000) => {
    clearTimeout(offerTimer);
    if (!ageConfirmed || !offer || dismissed || read('sessionStorage', offerKey) === '1') return;
    offerTimer = setTimeout(() => {
      if (dismissed || read('sessionStorage', offerKey) === '1') return;
      if (welcome?.open || age?.open) return;
      if (document.hidden || document.querySelector('dialog[open]')) { scheduleOffer(); return; }
      offer.hidden = false;
    }, delay);
  };
  const afterAge = () => {
    if (welcome && document.querySelector('.hero-background') && read('localStorage', welcomeKey) !== '1') {
      welcomeTimer = setTimeout(() => {
        if (document.querySelector('dialog[open]')) return;
        try { welcome.showModal(); write('localStorage', welcomeKey); } catch {}
      }, 200);
    }
    scheduleOffer();
  };
  const dismissOffer = () => {
    dismissed = true;
    clearTimeout(offerTimer);
    if (offer) offer.hidden = true;
    write('sessionStorage', offerKey);
  };
  age?.addEventListener('cancel', event => event.preventDefault());
  document.querySelector('[data-age-accept]')?.addEventListener('click', () => {
    ageConfirmed = true;
    write('localStorage', ageKey, String(Date.now() + 30 * 24 * 60 * 60 * 1000));
    age?.close();
    afterAge();
  });
  document.querySelector('[data-age-decline]')?.addEventListener('click', () => window.location.assign('https://www.disney.com/'));
  document.querySelectorAll('[data-close-book-welcome]').forEach(button => button.addEventListener('click', () => welcome?.close()));
  welcome?.addEventListener('close', () => scheduleOffer());
  document.querySelector('[data-close-book-promo]')?.addEventListener('click', dismissOffer);
  document.querySelector('.book-promo-link')?.addEventListener('click', dismissOffer);
  if (!ageConfirmed && age) {
    try { age.showModal(); } catch {}
  } else {
    afterAge();
  }
  window.addEventListener('pagehide', () => { clearTimeout(welcomeTimer); clearTimeout(offerTimer); }, {once: true});
})();
